module.exports = __webpack_public_path__ + "static/aws_security_group-1822996c25a5fb3ffcc5ce72e15a754c.png";